import { z } from 'zod'

export const CONNECTORS_ACCESS_FLAG = 'connectors_access'

export const DEFAULT_CONNECTOR_ACCESS = {
  google_calendar: true,
  outlook_calendar: true,
  slack: true,
  // TODO: Graduate each connector below to always on after its broader rollout is complete.
  gmail: false,
  notion: false,
  github: false,
  linear: false,
}

export type ConnectorAccess = typeof DEFAULT_CONNECTOR_ACCESS
export type ConnectorAccessKey = keyof ConnectorAccess

const connectorAccessOverride = z.boolean()

export const resolveConnectorAccess = (isEnabled: boolean | undefined, payload: unknown): ConnectorAccess => {
  const access = { ...DEFAULT_CONNECTOR_ACCESS }
  if (isEnabled !== true || payload === null || typeof payload !== 'object' || Array.isArray(payload)) return access

  for (const key of Object.keys(access) as ConnectorAccessKey[]) {
    if (!Object.prototype.hasOwnProperty.call(payload, key)) continue
    const value = connectorAccessOverride.safeParse((payload as Record<string, unknown>)[key])
    if (value.success) access[key] = value.data
  }

  return access
}
